import { MembershipType } from './member';

export enum PaymentStatus {
  Pending = 1,
  Paid = 2,
  Overdue = 3,
  Cancelled = 4,
}

/** Which fee rate was applied (so we know what they paid). */
export enum SubscriptionCategory {
  Regular = 1,
  Student = 2,
  Retired = 3,
  Honorary = 4,
  /** Institution &lt; €30,000 (ActiveI) */
  InstitutionCategory0 = 9,
  /** Institution €30,000–€100,000 (ActiveII) */
  InstitutionCategory1 = 10,
  /** Institution €100,000–€1,000,000 (ActiveIII) */
  InstitutionCategory2 = 11,
  /** Institution €1,000,000–€5,000,000 (ActiveIV) */
  InstitutionCategory3 = 12,
  /** Institution €5,000,000–€10,000,000 (ActiveV) */
  InstitutionCategory4 = 13,
  /** Institution &gt; €10,000,000 (ActiveVI) */
  InstitutionCategory5 = 14,
  /** Institution Benefactor */
  InstitutionBenefactor = 15,
}

export interface Payment {
  id: string;
  memberId: string;
  memberName: string;
  memberFirstName?: string;
  memberLastName?: string;
  memberEmail: string;
  memberPhone?: string;
  memberCardNumber?: string;
  membershipType: MembershipType;
  year: number;
  amount: number;
  /** Which fee rate was applied (so we know what they paid). */
  subscriptionCategory?: SubscriptionCategory;
  status: PaymentStatus;
  paidAt?: string;
  paymentMethod?: string;
  transactionReference?: string;
  notes?: string;
  hasReceipt: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PaymentListFilters {
  year?: number;
  status?: number;
  memberId?: string;
  membershipType?: number;
  paidFrom?: string;
  paidTo?: string;
  search?: string;
  lang?: string;
}

export interface PaymentSettings {
  id: string;
  year: number;
  regularAmount: number;
  studentAmount: number;
  retiredAmount: number;
  honoraryAmount: number;
  /** &lt; €30,000 (ActiveI) */
  institutionCategory0Amount: number;
  institutionCategory1Amount: number;
  institutionCategory2Amount: number;
  institutionCategory3Amount: number;
  /** €5M–€10M (ActiveV) */
  institutionCategory4Amount: number;
  /** &gt; €10M (ActiveVI) */
  institutionCategory5Amount: number;
  institutionBenefactorAmount: number;
  isActive: boolean;
}

export interface CreatePaymentRequest {
  memberId: string;
  year: number;
  amount?: number;
  subscriptionCategory?: SubscriptionCategory;
}

export interface UpdatePaymentStatusRequest {
  status: PaymentStatus;
  paymentMethod?: string;
  transactionReference?: string;
  notes?: string;
  paidAt?: string;
}

export interface GeneratePaymentsRequest {
  year: number;
  regularAmount: number;
  studentAmount: number;
  retiredAmount: number;
  honoraryAmount: number;
  institutionCategory0Amount: number;
  institutionCategory1Amount: number;
  institutionCategory2Amount: number;
  institutionCategory3Amount: number;
  institutionCategory4Amount: number;
  institutionCategory5Amount: number;
  institutionBenefactorAmount: number;
  generateIndividualPayments?: boolean;
  generateInstitutionPayments?: boolean;
}

export interface CheckoutPlan {
  paymentId: string;
  isBundled: boolean;
  years: number[];
  totalAmount: number;
  paymentIds: string[];
}

export interface GeneratePaymentsResult {
  year: number;
  settingsSaved: boolean;
  individualsCreated: number;
  individualsSkipped: number;
  institutionsCreated: number;
  institutionsSkipped: number;
}
